import { render, staticRenderFns } from "./AddFeedbackDialog.vue?vue&type=template&id=1290e236&"
import script from "./AddFeedbackDialog.vue?vue&type=script&lang=js&"
export * from "./AddFeedbackDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports